import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "50",
  height: "42",
  viewBox: "0 0 50 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0H46C48.2091 0 50 1.79086 50 4V38C50 40.2091 48.2091 42 46 42H0V0Z",
      fill: "#AA1E2D"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "24.1617",
      cy: "19.9117",
      r: "7.1617",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("line", {
      x1: "30.2735",
      y1: "24.6093",
      x2: "35.2068",
      y2: "29.5426",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }